<template>
  <VAvatar
    :size="size"
    :color="backgroundColor"
    :variant="variant"
    :class="[{ 'bg-white': variant === 'outlined' }]"
  >
    <span data-testid="initials" :class="['font-semibold', textColor, fontSizeClass]">
      {{ initials }}</span
    >
  </VAvatar>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type AvatarType = 'patient' | 'physician' | 'user'

export interface PersonAvatarProps {
  firstName: string
  lastName: string
  type: AvatarType
  size?: number
}

const { lastName, firstName, type, size = 48 } = defineProps<PersonAvatarProps>()

const initials = computed(() => {
  return `${firstName?.charAt(0).toUpperCase()}${lastName?.charAt(0).toUpperCase()}`
})

const textColor = computed(() => {
  switch (type) {
    case 'patient':
      return 'text-consultation-card'
    case 'physician':
      return 'white'
    case 'user':
      return 'text-secondary-text'
    default:
      return 'black'
  }
})

const backgroundColor = computed(() => {
  switch (type) {
    case 'patient':
    case 'physician':
      return 'consultation-card'
    case 'user':
      return 'grey-200'
    default:
      return 'white'
  }
})

const variant = computed(() => {
  switch (type) {
    case 'patient':
      return 'outlined'
    case 'physician':
    case 'user':
      return 'flat'
    default:
      return 'flat'
  }
})

const fontSizeClass = computed(() => {
  if (size <= 24) return 'text-xs'
  if (size <= 32) return 'text-sm'
  return 'text-base'
})
</script>
